import React, { useEffect, useState, useRef } from "react"
import { validateModuleMatch } from "./utils"
import { initialModuleState } from "../initialModuleState"
/**
 * Fetches module data from SQL database including user module record and base module template.
 * @returns
 */
const useModuleDB = (moduleId, firebase, isModuleInteractive) => {
  const [userModuleData, setUserModuleData] = useState(null)
  const [isModuleLoading, setIsModuleLoading] = useState(!!moduleId) // Loading is false if no moduleId
  const [error, setError] = useState(null)
  // pull module template and user record, can compare and restart if they have diverged
  const [baseModuleTemplate, setBaseModuleTemplate] = useState(null)
  const [hasLoadedInitially, setHasLoadedInitially] = useState(false)
  const [userSQLId, setUserSQLId] = useState(null)

  const prevModuleIdRef = useRef() // Ref to store the previous value of moduleId
  const prevFirebaseRef = useRef() // Ref to store the previous value of firebase

  const isModulePrivateAndAuthoredByUser = `${userSQLId}` === baseModuleTemplate?.creator_id && baseModuleTemplate?.access_type === "private"

  const loadUserModuleRecord = async () => {
    const res = await firebase?.getUserModuleRecord(moduleId)
    const resUserModuleRecord = res?.data?.userModuleRecord
    const resBaseModuleTemplate = res?.data?.baseModuleTemplate
    const userSQLId = res?.data?.callerSQLUserId
    setUserSQLId(userSQLId)

    setBaseModuleTemplate(resBaseModuleTemplate)

    if (resBaseModuleTemplate?.module_json && resUserModuleRecord?.module_json) {
      // validation in order to restart the module if it has diverged from the created template, required to keep things synced
      const isValid = validateModuleMatch(resUserModuleRecord.module_json.sections, resBaseModuleTemplate.module_json.sections)

      // disabled validation, this is a temporary fix to allow users to continue working on their modules 

      // if (!isValid && isModuleInteractive && resUserModuleRecord.status === "in_progress") {
      //   await firebase.restartUserModule(moduleId)
      //   alert("Sorry, your module has diverged from the base template. We have restarted it for you.")
      //   if (typeof window !== "undefined") {
      //     window.location.reload()
      //   }
      // }
      // we have a user module record
      setUserModuleData(resUserModuleRecord)

      return resUserModuleRecord
    } else {
      // we don't have a user module record, so we use the base template
      setUserModuleData(resBaseModuleTemplate)
      return resBaseModuleTemplate
    }
  }

  const initializeModule = async () => {
    const res = await firebase?.getUserModuleRecord(moduleId)

    const resUserModuleRecord = res?.data?.userModuleRecord
    const resBaseModuleTemplate = res?.data?.baseModuleTemplate
    const userSQLId = res?.data?.callerSQLUserId
    setUserSQLId(userSQLId)

    setBaseModuleTemplate(resBaseModuleTemplate)

    if (resBaseModuleTemplate.module_json && resUserModuleRecord?.module_json) {
      // validation in order to restart the module if it has diverged from the created template, required to keep things synced
      const isValid = validateModuleMatch(resUserModuleRecord.module_json.sections, resBaseModuleTemplate.module_json.sections)
      if (!isValid && isModuleInteractive && resUserModuleRecord.status === "in_progress") {

        // disabled validation, this is a temporary fix to stop restarting modules

        // await firebase.restartUserModule(moduleId)
        // alert("Sorry, your module has diverged from the base template. We have restarted it for you.")
        // if (typeof window !== "undefined") {
        //   window.location.reload()
        // }
      }
      setUserModuleData(resUserModuleRecord)
    } else {
      setUserModuleData(resBaseModuleTemplate)
    }

    if (!resUserModuleRecord && isModuleInteractive) {
      // we don't have a user module record, so we create one
      await firebase?.createUserModule(moduleId)
    }
  }

  useEffect(() => {
    // // Access previous values
    // const prevModuleId = prevModuleIdRef.current
    // const prevFirebase = prevFirebaseRef.current


    // // Update refs with current values
    // prevModuleIdRef.current = moduleId
    // prevFirebaseRef.current = firebase

    const fetchData = async () => {
      try {
        if (hasLoadedInitially) {
          return
        }
        await initializeModule()
        setHasLoadedInitially(true)
      } catch (err) {
        console.error("Error fetching module data:", err)
      } finally {
        setIsModuleLoading(false) // Set loading to false after fetching data
      }
    }

    if (!!firebase) {
      fetchData()
    }
  }, [moduleId, firebase]) // Include firebase in the dependency array

  return { userModuleData, isModuleLoading, loadUserModuleRecord, error, baseModuleTemplate, userSQLId, isModulePrivateAndAuthoredByUser }
}

export default useModuleDB
